module.exports = __webpack_public_path__ + "static/media/Xoogle _Logo.8301675c.png";